import { render, staticRenderFns } from "./createExternal.vue?vue&type=template&id=6e458556&scoped=true"
import script from "./createExternal.vue?vue&type=script&lang=js"
export * from "./createExternal.vue?vue&type=script&lang=js"
import style0 from "./createExternal.vue?vue&type=style&index=0&id=6e458556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e458556",
  null
  
)

export default component.exports